<template>
    <!-- Slider main container -->
  <div ref="swiperBox" class="swiper-container">
      <!-- Additional required wrapper -->
      <div class="swiper-wrapper">
        <slot></slot>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
  </div>
</template>

<script>
// import Swiper from 'swiper'
import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([Navigation, Pagination])

export default {
  name: 'Swiper',
  props: {
    loop: {
      type: Boolean,
      required: false,
      default: false
    },
    direction: {
      type: String,
      required: false,
      default: 'horizontal'
    },
    maxslides: {
      type: Number,
      required: false,
      default: 3
    } /*,
    resizeHandler: {
      type: Boolean,
      required: false, // really???
      default: null
    } */
  },
  data: function () {
    return {
      swiper: null, // siwper element will be stored here
      swiperWrapperWidth: 0 // width of swiper's wrapper will be stored here
    }
  },
  computed: {
    resizeHandler: function () {
      return this.$root.resizeHandler
    }
  },
  mounted () {
    this.createSwiper()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize: function () {
      this.swiperWrapperWidth = this.$refs.swiperBox.offsetWidth
    },
    createSwiper () {
      this.swiper = new Swiper('.swiper-container', {
        // slidesPerView: 1,
        slidesPerView: 'auto',
        direction: this.direction,
        loop: this.loop,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        },
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        },
        // slidesOffsetBefore: 40,
        // slidesOffsetAfter: 40,
        breakpoints: {
          /*
          580: {
            spaceBetween: 15,
            slidesPerView: 2
          },
          */
          767: {
            spaceBetween: 40,
            slidesPerView: 2
          },
          980: {
            spaceBetween: 40,
            slidesPerView: 2
          },
          1180: {
            spaceBetween: 40,
            slidesPerView: 2
          },
          1280: {
            spaceBetween: 40,
            slidesPerView: this.maxslides
          }
        }
      })
    },
    updateSwiper () {
      console.log('Swiper updated')
      this.swiper.update()
    }
  },
  destroyed: function () {
    window.removeEventListener('resize', this.handleResize)
    var sw = this.swiper
    setTimeout(function () {
      sw.destroy()
    }, 2000)
  },
  watch: {
    resizeHandler: function () {
      this.updateSwiper()
    },
    swiperWrapperWidth: function (newValue, oldValue) {
      /*
      console.log(newValue)
      console.log('Update @' + newValue + ',  old value @' + oldValue)
      if (oldValue - newValue > 4 || newValue - oldValue > 4) {
        console.log('Größerer Unterschied')
      }
      */
      this.swiper.update()
    }
  }
}
</script>

<style scoped>
.swiper-container {
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 20px 15px;
  z-index: 1;
  width: 100%;
  height: auto;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: auto;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform;
  transition-property: transform,-webkit-transform;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  align-items: stretch;
}
.swiper-slide {
  /* font-size: 18px; */
  -webkit-flex-shrink: 0;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  height: auto;
  position: relative;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  -o-transition-property: transform;
  transition-property: transform;
  transition-property: transform,-webkit-transform;
  display: flex;
  align-items: stretch;
  justify-content: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
}
.swiper-button-next,
.swiper-button-prev {
  background-image: url('../assets/img/icons/sliderNext.svg');
}
.swiper-button-prev.swiper-button-disabled {
  left: -46px!important;
  opacity: 0;
}
.swiper-button-next.swiper-button-disabled {
  right: -46px!important;
  opacity: 0;
}
@media (max-width:766px) {
  .swiper-slide {
    width: 48%!important;
  }
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
}
@media (max-width:520px) {
  .swiper-slide {
    width: 90%!important;
  }
}
@media(min-width:767px) {
  .swiper-container {
    padding: 20px 40px;
  }
  .swiper-slide {
    width: 100%;
  }
}
</style>
